/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Haveanyissuespleasere4Inputs */

const en_settings_haveanyissuespleasere4 = /** @type {(inputs: Settings_Haveanyissuespleasere4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Have any issues, please reach out to`)
};

/**
* | output |
* | --- |
* | "Have any issues, please reach out to" |
*
* @param {Settings_Haveanyissuespleasere4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_haveanyissuespleasere4 = /** @type {((inputs?: Settings_Haveanyissuespleasere4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Haveanyissuespleasere4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_haveanyissuespleasere4(inputs)
});
export { settings_haveanyissuespleasere4 as "settings_haveAnyIssuesPleaseRe" }